import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import { TodasInscricoesScreen } from "@/Components/Populados/Viagem/Inscricao/TodasInscricoes/TodasInscricoesScreen";
import ViagemSintenticaScreen from "@/Components/Populados/Viagem/ViagemSintenticaScreen";
import { Col, Divider, Flex, Row, Typography } from "antd";
import React from "react";

const logoQuiron = require("@/Assets/logo-quiron.png");

export function Home() {
    return (
        <div>
            <Row gutter={[16, 16]}>
                <ComponentePermissao
                    permissoes={["DomainViagemRelatorioRelatorioAnaliticoDeViagens"]}
                    renderNaoPermitido={
                        <Col xs={24}>
                            <Typography.Text>
                                <Flex vertical align="center" gap={8}>
                                    <Typography.Title level={3} style={{ textAlign: "center" }}>
                                        Bem-vindo ao sistema Quiron.
                                    </Typography.Title>
                                    <img src={logoQuiron} width={"80px"} />
                                </Flex>
                            </Typography.Text>
                        </Col>
                    }
                >
                    <Col xs={24}>
                        <ViagemSintenticaScreen />
                    </Col>
                </ComponentePermissao>
            </Row>

            <Row></Row>
        </div>
    );
}
